import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCountries, getbundles, createCart } from "../api/index";
import { toast } from "react-toastify";
import Header from "../../header";
import styles  from  "../styles/style.module.css";
import contrybanner from "../../../assets/images/contrybanner.svg";
import flag from "../../../assets/images/flag.png";
import search from "../../../assets/images/search.svg";
import Footer from "../../footer";

const PARTNER_WEBSITE_ID = "6798f6584c9989f41ae281d";

const CountrySelectPage = () => {
  const [searchCountry, setSearchCountry] = useState<string>("");
  const [countriesData, setCountriesData] = useState<any>({ items: [], count: 0 });
  const [couponId, setCouponId] = useState<string>(""); // If you want to support coupon
  const navigate = useNavigate();

  useEffect(() => {
    const query: any = {
      page: 1,
      limit: 100,
      partnerWebsiteId: '667000f74e37cd362882386e',
    };
    if (searchCountry) {
      query.searchString = searchCountry;
    }
    getCountries(query, PARTNER_WEBSITE_ID)
      .then((res: any) => {
        setCountriesData({
          items: res?.data?.countries,
          count: res?.data?.count,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }, [searchCountry, couponId]);

  const cartCreate = (countryId: string) => {
    getbundles({
      // dataAmount: 2000,
      // duration: 15,
      countryId,
      isCountry: true,
    },"6798f6584c9989f41ae281d")
      .then((res: any) => {
        console.log(res, "res=====");
        if (res?.data[0]?._id && res?.statusCode === 200) {
          createCart({
            items: [
              {
                bundleId: "67ac54d7a43398c782c049a3",
                quantity: 1,
                price: Number(res?.data[0]?.price),
                countryId: countryId,
                Partnerwebsiteid: "6798f6584c9989f41ae281d"
              },
            ],
            // scratchCoupanId: couponId,
            cartType: 2,
          })
            .then((res: any) => {
              console.log(res, "res");
              if (res?.statusCode === 201 && res?.data?._id) {
                navigate(`/checkout/${res?.data?._id}?country=${countryId}`);
              }
            })
            .catch(() => { });
        }
        // setBundlesData({ items: res?.data, count: res?.count });
      })
      .catch((error) => {
        console.log(error);
        toast.error("Sorry!! Plan not found")
      });
  };
 const [isOn, setIsOn] = useState(false);
  return (
    <>
      <Header />
      <section style={{ background: "rgb(240, 246, 249)" }}>
        <div className="container">
        <div className={styles.homeSlids}>
          <div className="row align-items-center justify-content-center">            
            <div className={`${styles.innerHomeSlideLeft} col-md-6`}>
              <div className="stay-new">
                <span>
                  <i className="pe-2">
                    <img
                    alt="market"
                    width="20"
                    height="20"
                    decoding="async"
                    data-nimg="1"
                    src={flag}
                  />
                  </i>
                  
                  United Arab Emirates
                </span>
                <h1 className="mb-0">
                  <b>Lorem, ipsum dolor.</b>
                </h1>
                <h4>Lorem, ipsum dolor</h4>                
              </div>
            </div>
            <div className={`${styles.innerHomeSlideright} col-md-6`}>
              <img
                alt="Tourism eSim"
                loading="lazy"
                decoding="async"
                data-nimg="fill"
                className="img-fluid"
                src={contrybanner}
              />
            </div>
          </div>
        </div>
        </div>
      </section>
      <div className="country-select-page">
      <div className="container">
        <div className={styles.changecountry}>
          <h3>Select <span className="d-md-inline-block d-none"> your destination</span> country</h3>
          <div className="col-12">
          <div className="row align-items-center justify-content-start g-3 flex-row mb-4">
            <div className="col-lg-6 col-8">
               <div className="leftfilter position-relative">
              <i><img src={search} alt="" width={15} height={15} /></i>
              <input
                type="text"
                placeholder="Search Country"
                value={searchCountry}
                onChange={(e) => setSearchCountry(e.target.value)}
              />
            </div>
            </div>
            <div className="col-lg-6 col-4 text-end"> 
              <label className={styles.customtoggle}>
              <input type="checkbox" id="toggleRegion" checked={isOn}  onChange={() => setIsOn(!isOn)}/>
              <span className={`${styles.slider} ${isOn ? styles.on : styles.off}`}>
                  {isOn ? "OFF" : "Region"}
                </span>
            </label>
            </div>
           
           
          </div>
          </div>
          <div className="countryList">
            <ul className="row align-items-center justify-content-start g-xl-4 g-lg-3 g-2 p-0">
              {countriesData?.items?.length > 0 ? (
                countriesData?.items?.map((item: any, index: number) => (
                  <li
                    className="col-xl-2 col-lg-3 col-md-3 col-4"
                    key={index}
                    onClick={() => cartCreate(item?._id)}
                  >
                    <div className="contrylist">
                    <div className="w-100 mb-3">
                      <img src={item?.flagImageUrl} alt="" className="img-fluid shadow-sm rounded-circle"/>
                    </div>
                    <div>
                      <h4 className="clamp clamp1">{item?.name}</h4>
                      <h6>From ₹100.00</h6>
                    </div>
                    </div>
                  </li>
                ))
              ) : (
                <div> Country not found. </div>
              )}
            </ul>
            {/* <ul>
            {countriesData?.items?.length > 0 ? (
              countriesData?.items?.map((item: any, index: number) => (
                <li key={index} onClick={() => cartCreate(item?._id)}>
                  <img src={item?.flagImageUrl} alt="" />
                  <span>{item?.name}</span>
                </li>
              ))
            ) : (
              <div>Country not found.</div>
            )}
          </ul> */}
          </div>
        </div>
      </div>
      </div>
      <Footer />
    </>
  );
};

export default CountrySelectPage; 